<template>
  <modal :fullscreen="true" :show="show" @close="close">
    <v-flex slot="title">{{ title }}</v-flex>

    <div>
      <v-layout column>
        <v-flex xs12>
          <text-input :model="$schema.name" />
        </v-flex>

        <teryt-form v-if="show" :schema="$schema" :row="true" />

        <v-flex xs12>
          <v-layout row wrap>
            <v-flex pr-2 xs6>
              <text-input :model="$schema.homeNumber" />
            </v-flex>

            <v-flex pl-2 xs6>
              <text-input :model="$schema.localNumber" />
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex xs12>
          <text-input :model="$schema.postalCode" />
        </v-flex>

        <v-flex class="mb-4" xs12>
          <html-editor :schema="$schema.description" />
        </v-flex>
      </v-layout>
    </div>

    <v-layout slot="actions">
      <v-spacer />

      <v-btn color="error" flat @click="close">Anuluj</v-btn>

      <v-btn color="success" flat @click="save">Zapisz</v-btn>
    </v-layout>
  </modal>
</template>

<script>
import { ProfileType } from '@witkac/kartamiejska-shared';
import { schemaMixin, WSchema } from '@witkac/vuetify-components';
import { mapState } from 'vuex';

import HtmlEditor from '@/components/forms/HtmlEditor';
import ImagesList from '@/components/forms/ImagesList';
import SingleImage from '@/components/forms/SingleImage';
import TerytForm from '@/components/forms/TERYTForm';
import TextInput from '@/components/forms/TextInput';
import Modal from '@/components/material/Modal';
import { modalMixin } from '@/mixins/modal';
import { notificationsMixin } from '@/mixins/notifications';
import schema from '@/schemas/collectionPoint.schema';

const emptyData = {
  name: '',
  description: '',
  woj: '',
  pow: '',
  gmi: '',
  terc: '',
  city: '',
  simc: '',
  street: '',
  ulic: '',
  postalCode: '',
  homeNumber: '',
  localNumber: ''
};

const messages = {
  added: 'Poprawnie dodano punkt odbioru.',
  addError: 'Nie udało się dodać punktu odbioru.',
  updated: 'Zaktualizowano punkt odbioru.',
  updateError: 'Nie udało się zaktualizować punktu odbioru.',
  deleted: 'Usunięto punkt odbioru.',
  deleteError: 'Nie udało się usunąć punktu odbioru.',
  listError: 'Nie udało się pobrać listy punktów odbioru.'
};

// @vuese
// Modal dodawania Partnera
// @group Partners
export default {
  components: { Modal, WSchema, TerytForm, TextInput, HtmlEditor },
  mixins: [schemaMixin, notificationsMixin],
  schema,
  computed: {
    title() {
      return `${this.idToEdit ? 'Edytuj' : 'Dodaj'} punkt odbioru`;
    }
  },
  props: {
    // Boolean kontrolujący widoczność modala
    show: {
      type: Boolean,
      required: true,
      default: false
    },
    // id do edycji
    idToEdit: {
      type: Number,
      required: false
    }
  },
  data() {
    return {
      model: { ...emptyData }
    };
  },
  methods: {
    // @vuese
    // Potwierdzenie zamknięcia formularza w przypadku zmian
    close() {
      if (this.$schema.$dirtyList().length !== 0) {
        this.$store.dispatch('showConfirmDialog');
      } else {
        this.closeModal();
      }
    },
    // @vuese
    // Funkcja emituje event `close` do zamknięcia modalu
    closeModal() {
      // Zamyka modal
      this.$emit('close');
    },
    // @vuese
    // Metoda czyści pola formularza
    clearForm() {
      this.$schema.$setData({ ...emptyData });
    },
    // @vuese
    // Metoda zapisuje Partnera
    save() {
      if (!this.$schema.$validateAll().length) {
        this.$store
          .dispatch(`collectionPoint/${this.idToEdit ? 'update' : 'add'}`, {
            id: this.idToEdit,
            collectionPoint: this.model
          })
          .then(() => {
            this.$emit('saved', this.model);
            this.notifySuccess(this.idToEdit ? messages.updated : messages.added);
            this.closeModal();
          })

          .catch(() => {
            this.notifyError(this.idToEdit ? messages.updateError : messages.addError);
          });
      } else {
        this.notifyError('Błędnie wypełniony formularz');
      }
    }
  },
  watch: {
    show(val) {
      if (val) {
        if (this.idToEdit) {
          this.$schema.$setData(this.$store.state.collectionPoint.data);
        } else {
          this.clearForm();
        }
      }
    }
  }
};
</script>
